import { buildFormSelector } from '../utils';

/**
 * @param RegistrationForm Base widget for extending
 * @returns SignInToBuyRegistrationForm widget
 */
function SignInToBuyRegistrationFormClassCreator(RegistrationForm: import('core/account/RegistrationForm').TRegistrationForm) {
    class SignInToBuyRegistrationForm extends RegistrationForm {
        prefs() {
            return {
                friendlyCaptchaEnabled: false,
                ...super.prefs()
            };
        }

        /**
         * @description Initialize widget logic
         */
        init() {
            super.init();

            if (this.prefs().friendlyCaptchaEnabled) {
                const form = this.ref('self').get() as HTMLFormElement;
                const selector = buildFormSelector(form, false);

                if (selector) {
                    this.eventBus().emit('captcha.init', selector);
                }
            }
        }

        /**
         * @description Handle server response
         * @param data - Server JSON response once form submitted
         */
        onSubmitted(data: TServerResponse) {
            if (data.success) {
                this.emit('signintobuyformsubmit', data);
                this.eventBus().emit('signintobuyregistration.submit');
            }

            super.onSubmitted(data);
        }
    }

    return SignInToBuyRegistrationForm;
}

export type TSignInToBuyRegistrationForm = ReturnType<typeof SignInToBuyRegistrationFormClassCreator>;

export type TSignInToBuyRegistrationFormInstance = InstanceType<TSignInToBuyRegistrationForm>;

export default SignInToBuyRegistrationFormClassCreator;
